<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="59" [hidden]="!isHostedEnabled"></ziro-breadcrumb-card-item>
      @if (!isHostedEnabled) {
        <ziro-breadcrumb-card-item
          [innerHTML]="'tkey;admin.proxy_server_management.proxy_feature_settings.about' | escapeHtml"
        ></ziro-breadcrumb-card-item>
      }
    </ziro-breadcrumbs>
    @if (isLoading) {
      <ziro-loading-block></ziro-loading-block>
    }
    @if (!isLoading && isHostedEnabled) {
      <ziro-ms-proxy-feature-settings-form
        [entity]="zpmProxyFeatureSettingsEntity"
      ></ziro-ms-proxy-feature-settings-form>
    }
    @if (!isLoading && !isHostedEnabled) {
      <ziro-cisco-proxy-feature-settings-form
        [entity]="zpcProxyFeatureSettingsEntity"
      ></ziro-cisco-proxy-feature-settings-form>
    }
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
